import { render, staticRenderFns } from "./TPV.vue?vue&type=template&id=f4ebf45e&scoped=true"
import script from "./TPV.vue?vue&type=script&lang=js"
export * from "./TPV.vue?vue&type=script&lang=js"
import style0 from "./TPV.vue?vue&type=style&index=0&id=f4ebf45e&prod&lang=scss"
import style1 from "./TPV.vue?vue&type=style&index=1&id=f4ebf45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ebf45e",
  null
  
)

export default component.exports